import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { color, font } = baseVariables;

export const StyledSearchFormDesktop = styled.div<{ isSearchResultPage?: boolean }>`
  .find-cta {
    width: 100%;
    height: ${toRem(52)};
  }
  .shared-search-row {
    padding: ${props => (props.isSearchResultPage ? `0` : `0 ${toRem(24)}`)};
    min-height: ${toRem(80)};
  }
  .tab-container {
    padding: ${props => (props.isSearchResultPage ? `0 0 ${toRem(24)}` : `0 ${toRem(24)} ${toRem(24)}`)};

    .m-standard-tab-list {
      border-bottom-color: ${color.neutral30};
      &-item {
        max-width: ${toRem(230)};
      }
      .tabIconText {
        .t-font-m {
          font-weight: ${font.fontWeightMedium};
          color: ${color.neutral40};
        }
        .iconContainer {
          line-height: ${toRem(32)};
        }
        &:hover {
          .t-font-m {
            color: ${color.base10};
          }
        }
      }
      .active {
        .t-font-m {
          color: ${color.base10};
        }
      }
    }

    .tabpage-edge {
      margin-top: ${toRem(16)};
    }

    .tabpage-container {
      display: none;
    }

    /*
     * The shared TabContainer uses Glide.js internally as a carousel.
     * In this search form desktop layout, tabs must always render as a static
     * flex row (never a sliding carousel). The overrides below disable Glide's
     * carousel behaviour, scoped only to this component via StyledSearchFormDesktop.
     *
     * Why !important is required on transform/width:
     * Glide.js applies these as JavaScript inline styles after mount.
     * Inline styles have the highest CSS specificity and cannot be overridden
     * without !important. This is unavoidable without modifying the shared TabContainer.
     *
     * These rules will not affect other carousel or tab instances on the page.
     */

    /* Arrow controls are never needed for this 3-tab search form row.
     * TODO: replace with conditional render if TabContainer is refactored. */
    .carouselControlType1 {
      display: none;
    }

    /* Glide sets inline width per slide based on perView=2 initial state.
     * !important overrides the inline style before the debounced resize corrects it. */
    .glide__slide {
      width: auto !important;
    }

    /* Glide sets an inline transform to shift the track.
     * !important prevents tabs being clipped off-screen on first render. */
    .glide__slides {
      transform: none !important;
      flex-wrap: nowrap;
      width: 100% !important;
    }

    .glide__track {
      overflow: hidden;
    }
  }
`;
